import { h } from 'preact'
import { FilterOptionItem } from './interfaces'
import { getPlaceholderText } from './utils'
import ButtonControl from '../button-control'
import SimpleFilterSelector from '../overview/filters/SimpleFilterSelector'
import Icon from '../assets'

interface FilterData {
    id: string,
    name: string,
    customClassName: string,
    title: string,
    isDropdownOpen: boolean,
    toggleDropdown: (value: boolean) => void,
    resetDropdown: () => void,
    onClear: (e: Event) => void,
    onChange: (data: any) => void,
    items: Array<FilterOptionItem>,
    selectedItems: Array<string>,
    isLoading: boolean
}

const DashboardSimpleFilter = ({ id, name, customClassName, title, isDropdownOpen, toggleDropdown, resetDropdown, items, selectedItems, onClear, onChange, isLoading }: FilterData) => {
  const placeholderAdditionalText = getPlaceholderText(items, selectedItems)

  return (
    <div className={`filter-option filter-option-${customClassName}`}>
      <ButtonControl newStyle disabled={isLoading} title={<FilterTitle title={title} onClear={onClear} placeholderAdditionalText={placeholderAdditionalText} isDropdownOpen={isDropdownOpen} selectedItems={selectedItems} />}
        size='medium'
        class={`${customClassName}-open-button filter-option-button ${isDropdownOpen ? 'dropdown-open' : ''} `}
        onClick={() => toggleDropdown(!isDropdownOpen)} />
      {isDropdownOpen &&
        <div className='overview__filters-box-container'>
          <div className='overview__filters-box'>
            <SimpleFilterSelector id={id} name={name} isSearchable items={items} selectedFilterItems={selectedItems}>
              {({ isApplyButtonDisabled, data }: { isApplyButtonDisabled: boolean, data: any }) =>
                <div>
                  <hr />
                  <div className='overview__filters-box-buttons'>
                    <ButtonControl
                      newStyle
                      size='small'
                      variant='brand'
                      title='Apply'
                      disabled={isApplyButtonDisabled}
                      onClick={() => onChange(data)} />
                    <ButtonControl newStyle size='small' title='Cancel' onClick={resetDropdown} />
                  </div>
                </div>
              }
            </SimpleFilterSelector>
          </div>
        </div>}
    </div>)
}

interface FilterTitleProps {
    title: string,
    placeholderAdditionalText?: string,
    onClear: (e: Event) => void,
    selectedItems: Array<string>,
    isDropdownOpen: boolean
}

const FilterTitle = ({ title, placeholderAdditionalText, onClear, selectedItems, isDropdownOpen }: FilterTitleProps) => (
  <div>
    <span className={`dropdown-placeholder-text ${isDropdownOpen ? 'filter-dropdown-open' : ''}`}> {title}</span>
    <span className={`dropdown-selected-placeholder ${isDropdownOpen ? 'filter-dropdown-open' : ''}`}>{placeholderAdditionalText}</span>
    {selectedItems.length > 0
      ? <span className='icon-cancel-wrapper' onClick={(e) => onClear(e)}><Icon icon='cancel'
        customClass='icon-cancel'
        height={16}
        width={16} /> </span> : null}</div>
)

export default DashboardSimpleFilter
